import type { RouteLocation, RouteLocationRaw } from '#vue-router'

export default async (to: RouteLocationRaw | RouteLocation, options?: Object) =>
  await navigateTo(getLocalePath(to), options)
